"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_5.ts
const product_types_1 = require("../types/product.types");
const products = [
    // Manejo PreHospitalario del Paciente Gran Quemado
    {
        id: 786,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-prehospitalario-paciente-gran-quemado-2026",
        title: "Curso Manejo PreHospitalario del Paciente Gran Quemado",
        name: "Curso Manejo PreHospitalario del Paciente Gran Quemado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Abordaje seguro de quemaduras extensas y evaluación del daño. Estabilización y coordinación con unidades especializadas.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/786/image3"],
        banner: ["/786/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-prehospitalario-del-paciente-gran-quemado-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [787, 788],
        multiple_languages: false,
    },
    // Curso Manejo PreHospitalario del Paciente Gran Quemado - Idiomas
    {
        id: 787,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-prehospitalario-paciente-gran-quemado-2026-es",
        title: "Curso Manejo PreHospitalario del Paciente Gran Quemado",
        name: "Curso Manejo PreHospitalario del Paciente Gran Quemado",
        short: "1.) Manejo PreHospitalario del Paciente Gran Quemado",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/786/image3"],
        banner: ["/786/image3"],
        link: "/tienda/cursos/formacion-policial/curso-manejo-prehospitalario-paciente-gran-quemado-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 786,
        default_in_parent: true,
        evolmind: { course_id: 690, group_id: [2376] },
    },
    // 788. Curs Atenció PreHospitalària del Pacient Gran Cremat - Idiomes
    {
        id: 788,
        tax: 0.0,
        sku: "iopos.course.online.curso-manejo-prehospitalario-paciente-gran-quemado-2026-ca",
        title: "Curs Atenció PreHospitalària del Pacient Gran Cremat",
        name: "Curs Atenció PreHospitalària del Pacient Gran Cremat",
        short: "2.) Atenció PreHospitalària del Pacient Gran Cremat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/786/image3"],
        banner: ["/786/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-en-incendio-y-estructuras-colapsadas-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 786,
        evolmind: { course_id: 693, group_id: [2379] },
    },
    // Rescate de Vehículos Pesados y Comerciales
    {
        id: 789,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-vehiculos-pesados-y-comerciales-2026",
        title: "Curso Rescate de Vehículos Pesados y Comerciales",
        name: "Curso Rescate de Vehículos Pesados y Comerciales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Técnicas de extracción de víctimas en accidentes con camiones y buses. Uso de herramientas y coordinación con cuerpos de rescate.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/789/image3"],
        banner: ["/789/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescazte-de-vehiculos-pesados-y-comerciales-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [790, 791],
        multiple_languages: false,
    },
    // Curso Rescate de Vehículos Pesados y Comerciales - Idiomas
    {
        id: 790,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-vehiculos-pesados-y-comerciales-2026-es",
        title: "Curso Rescate de Vehículos Pesados y Comerciales",
        name: "Curso Rescate de Vehículos Pesados y Comerciales",
        short: "1.) Rescate de Vehículos Pesados y Comerciales",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/789/image3"],
        banner: ["/789/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-de-vehiculos-pesados-y-comerciales-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 789,
        default_in_parent: true,
        evolmind: { course_id: 702, group_id: [2388] },
    },
    // Curs Rescat de Vehicles Pesats i Comercials - Idiomes
    {
        id: 791,
        tax: 0.0,
        sku: "iopos.course.online.curso-rescate-vehiculos-pesados-y-comerciales-2026-ca",
        title: "Curs Rescat de Vehicles Pesats i Comercials",
        name: "Curs Rescat de Vehicles Pesats i Comercials",
        short: "2.) Rescat de Vehicles Pesats i Comercials",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/789/image3"],
        banner: ["/789/image3"],
        link: "/tienda/cursos/formacion-policial/curso-rescate-de-vehiculos-pesados-y-comerciales-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 789,
        evolmind: { course_id: 705, group_id: [2391] },
    },
    // Herramientas de Asistencia Básica a la Conducta Suicida
    {
        id: 792,
        tax: 0.0,
        sku: "iopos.course.online.curso-herramientas-asistencia-basica-conduca-suicida-2026",
        title: "Curso de Herramientas de Asistencia Básica a la Conducta Suicida",
        name: "Curso de Herramientas de Asistencia Básica a la Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Estrategias de contención y diálogo en crisis suicidas. Intervención básica adaptada a agentes de primera respuesta.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/792/image3"],
        banner: ["/792/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-herramientas-basicas-a-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [793, 794],
        multiple_languages: false,
    },
    // Curso de Herramientas de Asistencia Básica a la Conducta Suicida - Idiomas
    {
        id: 793,
        tax: 0.0,
        sku: "iopos.course.online.curso-herramientas-asistencia-basica-conduca-suicida-2026-es",
        title: "Curso de Herramientas de Asistencia Básica a la Conducta Suicida",
        name: "Curso de Herramientas de Asistencia Básica a la Conducta Suicida",
        short: "1.) Herramientas de Asistencia Básica a la Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/792/image3"],
        banner: ["/792/image3"],
        link: "/tienda/cursos/formacion-policial/curso-de-herramientas-de-asistencia-basica-a-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 792,
        default_in_parent: true,
        evolmind: { course_id: 708, group_id: [2394] },
    },
    // Curs d'Eines d'Assistència Bàsica a la Conducta Suicida - Idiomes
    {
        id: 794,
        tax: 0.0,
        sku: "iopos.course.online.curso-herramientas-asistencia-basica-conduca-suicida-2026-ca",
        title: "Curs d'Eines d'Assistència Bàsica a la Conducta Suicida",
        name: "Curs d'Eines d'Assistència Bàsica a la Conducta Suicida",
        short: "2.) Eines d'Assistència Bàsica a la Conducta Suicida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/792/image3"],
        banner: ["/792/image3"],
        link: "/tienda/cursos/formacion-policial/curso-herramientas-de-asistencia-basica-a-la-conducta-suicida-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 792,
        evolmind: { course_id: 711, group_id: [2397] },
    },
    // Actualización En Medicina Táctica
    {
        id: 795,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-medicina-tactica-2026",
        title: "Curso Actualización En Medicina Táctica",
        name: "Curso Actualización En Medicina Táctica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "Técnicas avanzadas de atención médica en entornos hostiles o de riesgo. Enfoque táctico-operativo para contextos policiales o militares.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/795/image3"],
        banner: ["/795/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-en-medicina-tactica-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [796, 797],
        multiple_languages: false,
    },
    // Curso Actualización En Medicina Táctica - Idiomas
    {
        id: 796,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-medicina-tactica-2026-es",
        title: "Curso Actualización En Medicina Táctica",
        name: "Curso Actualización En Medicina Táctica",
        short: "1.) Actualización En Medicina Táctica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/795/image3"],
        banner: ["/795/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-en-medicina-tactica-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 795,
        default_in_parent: true,
        evolmind: { course_id: 624, group_id: [2310] },
    },
    // Curs Actualització En Medicina Tàctica - Idiomes
    {
        id: 797,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-medicina-tactica-2026-ca",
        title: "Curs Actualització En Medicina Tàctica",
        name: "Curs Actualització En Medicina Tàctica",
        short: "2.) Actualització En Medicina Tàctica",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.MEDICINA_LEGAL_Y_ASISTENCIA_SANITARIA,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/795/image3"],
        banner: ["/795/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-en-medicina-tactica-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 795,
        evolmind: { course_id: 627, group_id: [2313] },
    },
    // Metodología OSINT para Investigar en Internet
    {
        id: 798,
        tax: 0.0,
        sku: "iopos.course.online.curso-metodologia-osint-para-investigar-en-internet-2026",
        title: "Curso Metodología de Inteligencia de Fuentes Abiertas (OSINT) para Investigar en Internet",
        name: "Curso Metodología de Inteligencia de Fuentes Abiertas (OSINT) para Investigar en Internet",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Aprende a recopilar, analizar y verificar información disponible en la red mediante técnicas OSINT, con aplicaciones prácticas para investigación, análisis de riesgos y ciberinteligencia.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/798/image3"],
        banner: ["/798/image3"],
        link: "/tienda/cursos/formacion-policial/curso-metodologia-osint-para-investigar-en-internet-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [799, 800],
        multiple_languages: false,
    },
    // Curso Metodología de Inteligencia de Fuentes Abiertas (OSINT) para Investigar en Internet - Idiomas
    {
        id: 799,
        tax: 0.0,
        sku: "iopos.course.online.curso-metodologia-osint-para-investigar-en-internet-2026-es",
        title: "Curso Metodología de Inteligencia de Fuentes Abiertas (OSINT) para Investigar en Internet",
        name: "Curso Metodología de Inteligencia de Fuentes Abiertas (OSINT) para Investigar en Internet",
        short: "1.) Metodología OSINT para Investigar en Internet",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/798/image3"],
        banner: ["/798/image3"],
        link: "/tienda/cursos/formacion-policial/curso-metodologia-osint-para-investigar-en-internet-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 798,
        default_in_parent: true,
        evolmind: { course_id: 714, group_id: [2400] },
    },
    // Curs Metodologia d'Intel·ligència de Fonts Obertes (OSINT) per Investigar a Internet - Idiomes
    {
        id: 800,
        tax: 0.0,
        sku: "iopos.course.online.curso-metodologia-osint-para-investigar-en-internet-2026-ca",
        title: "Curs Metodologia d'Intel·ligència de Fonts Obertes (OSINT) per Investigar a Internet",
        name: "Curs Metodologia d'Intel·ligència de Fonts Obertes (OSINT) per Investigar a Internet",
        short: "2.) Metodologia OSINT per Investigar a Internet",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/798/image3"],
        banner: ["/798/image3"],
        link: "/tienda/cursos/formacion-policial/curso-metodologia-ostin-para-investigar-en-internet-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 798,
        evolmind: { course_id: 717, group_id: [2403] },
    },
    // Actuación contra el ciberacoso: prevención e intervención eficaz
    {
        id: 801,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-contra-el-ciberacoso-prevencion-e-intervencion-efiacaz-2026",
        title: "Curso Actuación contra el ciberacoso: prevención e intervención eficaz",
        name: "Curso Actuación contra el ciberacoso: prevención e intervención eficaz",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Conoce los fundamentos del ciberacoso, sus manifestaciones y consecuencias, y adquiere herramientas para su detección, prevención y respuesta desde un enfoque práctico y multidisciplinar.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/801/image3"],
        banner: ["/801/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-contra-el-ciberacoso-prevencion-e-intervencion-eficaz-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [802, 803],
        multiple_languages: false,
    },
    // Curso Actuación contra el ciberacoso: prevención e intervención eficaz - Idiomas
    {
        id: 802,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-contra-el-ciberacoso-prevencion-e-intervencion-efiacaz-2026-es",
        title: "Curso Actuación contra el ciberacoso: prevención e intervención eficaz",
        name: "Curso Actuación contra el ciberacoso: prevención e intervención eficaz",
        short: "1.) Actuación contra el ciberacoso: prevención e intervención eficaz",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/801/image3"],
        banner: ["/801/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-contra-el-ciberacoso-prevencion-e-intervencion-eficaz-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 801,
        default_in_parent: true,
        evolmind: { course_id: 720, group_id: [2406] },
    },
    // Curs d'Actuació contra el ciberassetjament: prevenció i intervenció eficaç - Idiomes
    {
        id: 803,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-contra-el-ciberacoso-prevencion-e-intervencion-efiacaz-2026-es",
        title: "Curs d'Actuació contra el ciberassetjament: prevenció i intervenció eficaç",
        name: "Curs d'Actuació contra el ciberassetjament: prevenció i intervenció eficaç",
        short: "2.) Actuació contra el ciberassetjament: prevenció i intervenció eficaç",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/801/image3"],
        banner: ["/801/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-contra-el-ciberacoso-prevenir-y-actuar-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 801,
        evolmind: { course_id: 723, group_id: [2409] },
    },
    // Ciberseguridad y seguridad informativa
    {
        id: 804,
        tax: 0.0,
        sku: "iopos.course.online.curso-ciber-y-seg-de-la-informacion-2026",
        title: "Curs Ciberseguretat i Seguretat de la Informació",
        name: "Curs Ciberseguretat i Seguretat de la Informació",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "Formació especialitzada orientada a garantir la protecció dels sistemes, les dades i la informació digital mitjançant criteris tècnics, preventius i jurídicament segurs.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/804/image4"],
        banner: ["/804/image4"],
        link: "/tienda/cursos/formacion-policial/curso-ciberseguridad-y-seguridad-de-la-informacion-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [805, 806],
        multiple_languages: false,
    },
    // Curso Fundamentos de Ciberseguridad y Seguridad de la Información - Idiomas
    {
        id: 805,
        tax: 0.0,
        sku: "iopos.course.online.curso-ciber-y-seg-de-la-informacion-2026-es",
        title: "Curso Ciberseguridad y Seguridad de la Información",
        name: "Curso Ciberseguridad y Seguridad de la Información",
        short: "1.) Ciberseguridad y Seguridad de la Información",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/804/image3"],
        banner: ["/804/image3"],
        link: "/tienda/cursos/formacion-policial/curso-ciberseguridad-y-seguridad-de-la-informacion-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 804,
        default_in_parent: true,
        evolmind: { course_id: 726, group_id: [2412] },
    },
    // Curs Fonaments de Ciberseguretat i Seguretat de la Informació - Idiomes
    {
        id: 806,
        tax: 0.0,
        sku: "iopos.course.online.curso-ciber-y-seg-de-la-informacion-2026-ca",
        title: "Curs Ciberseguretat i Seguretat de la Informació",
        name: "Curs Ciberseguretat i Seguretat de la Informació",
        short: "1.) Ciberseguretat i Seguretat de la Informació",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TECNOLOGIAS_Y_CIBERSEGURIDAD,
        ],
        description: "",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/804/image3"],
        banner: ["/804/image3"],
        link: "/tienda/cursos/formacion-policial/curso-ciberseguridad-y-seguridad-de-la-informacion-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 804,
        evolmind: { course_id: 729, group_id: [2415] },
    },
    // Curs Presencial ACTIC nivell mitjà (10 h) - 2026
    {
        id: 807,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h) [2026]",
        name: "Curs Presencial ACTIC nivell mitjà (14 h) [2026]",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 2 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image5"],
        banner: ["/807/image5"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-14-hores-2026/",
        created_at: "2026-03-09 00:00:01",
        start_at: "2026-03-09 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        childs: [809, 810, 1204, 1206],
        hero: {
            firstTitle: "Curs Presencial ACTIC nivell mitjà",
            secondTitle: "14 hores - 2026",
            thirdTitle: "Aconsegueix el **certificat ACTIC nivell mitjà** en només **2 dies** amb el nostre **curs intensiu i presencial**. **Ràpid**, **efectiu** i amb **suport personalitzat**!",
            landscape: "/807/hero_h.jpg",
            portrait: "/807/hero_v.jpg",
        },
    },
    // Curs Presencial ACTIC nivell mitjà (10 h) - Edició #1: 21, 22 d'abril 2026
    {
        id: 809,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-21-22-abr-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h - 21 i 22 d'abril de 10:00 a 17:00 h)",
        name: "Curs Presencial ACTIC nivell mitjà (14 h - 21 i 22 d'abril de 10:00 a 17:00 h)",
        short: "1.) Curs ACTIC nivell mitjà (21 i 22 d'abril de 10:00 - 17:00)",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 3 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image5"],
        banner: ["/807/image5"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-7-hores-2026-21-abril/",
        created_at: "2026-03-09 00:00:01",
        start_at: "2026-03-09 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 807,
        limit: 30,
        default_in_parent: true,
        evolmind: { course_id: 492, group_id: [2460] },
    },
    // Curs Presencial ACTIC nivell mitjà (10 h) - Edició #2: 28 i 29 de març 2026
    {
        id: 810,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-18-19-abril-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h - 18 i 19 d'abril de 10:00 a 17:00 h)",
        name: "Curs Presencial ACTIC nivell mitjà (14 h - 18 i 19 d'abril de 10:00 a 17:00 h)",
        short: "2.) Curs ACTIC nivell mitjà (18 i 19 d'abril de 10:00 - 17:00)",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 3 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image5"],
        banner: ["/807/image5"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-14-hores-2026-18-19-abril/",
        created_at: "2026-03-20 00:00:01",
        start_at: "2026-03-20 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        parent: 807,
        evolmind: { course_id: 492, group_id: [3151] },
    },
    // Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h]
    {
        id: 811,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.psicos-aptitudinals-mossos-2025",
        title: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h]",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h]",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Supera la prova de psicotècnics a la primera i destaca entre els aspirants!",
        enabled: false,
        stock: false,
        stock_message: "Sense disponiblitat.",
        price: 109.99,
        shipment: 0.0,
        images: ["/811/image1"],
        banner: ["/811/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-2025/",
        created_at: "2025-07-31 00:00:01",
        start_at: "2025-07-31 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        limit: 30,
        /*childs: [812, 921, 922],*/
    },
    // Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] - 28 setembre
    {
        id: 812,
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.classroom.psicos-aptitudinals-mossos-2025-28-set",
        title: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (28 setembre)",
        name: "Curs Presencial de Psicotècnics Apt. Mossos 2025 [8 h] (28 setembre)",
        short: "Curs Psicotècnics (Diumenge 28 setembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Supera la prova de psicotècnics a la primera i destaca entre els aspirants!",
        enabled: false,
        stock: false,
        stock_message: "Places esgotades!",
        price: 109.99,
        shipment: 0.0,
        images: ["/811/image1"],
        banner: ["/811/image1"],
        link: "/tienda/cursos/curs-presencial-psicotecnics-aptitudinals-2025/",
        created_at: "2025-07-31 00:00:01",
        start_at: "2025-07-31 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        parent: 811,
        default_in_parent: true,
        limit: 30,
        evolmind: { course_id: 355, group_id: [2631] },
    },
    // Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs)
    {
        id: 808,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisiques-4-classes-sant-adria-juliol-2025",
        title: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs)",
        name: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs)",
        description: "Amb el pack d'iOpos entrenaràs com un pro, amb sessions reals, consells personalitzats i tot el que necessites per superar les proves al màxim nivell.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 59.99,
        shipment: 0.0,
        images: ["/808/image1"],
        banner: ["/808/image1"],
        link: "/tienda/cursos/pack-juny-proves-fisiques-sant-adria/",
        created_at: "2025-05-27 00:00:01",
        start_at: "2025-05-27 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        childs: [813, 814],
    },
    // Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 1 classe)
    {
        id: 813,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisiques-sant-adria-juliol-2025-pack-1",
        title: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 1 classe)",
        name: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 1 classe)",
        short: "Pack Juliol Sant Adrià - 1 classe",
        description: "Amb el pack d'iOpos entrenaràs com un pro, amb sessions reals, consells personalitzats i tot el que necessites per superar les proves al màxim nivell.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 19.99,
        shipment: 0.0,
        images: ["/808/image1"],
        banner: ["/808/image1"],
        link: "/tienda/cursos/pack-juny-proves-fisiques-sant-adria/",
        created_at: "2025-05-27 00:00:01",
        start_at: "2025-05-27 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        calendly: { uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", units: 1 },
        discount_not_applicable: true,
        parent: 808,
    },
    // Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 4 classes)
    {
        id: 814,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Sports],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.pack-fisiques-sant-adria-juliol-2025-pack-4",
        title: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 4 classes)",
        name: "Pack Juliol Entrenament Proves Físiques (Sant Adrià del Besòs - 4 classes)",
        short: "Pack Juliol Sant Adrià - 4 classes",
        description: "Amb el pack d'iOpos entrenaràs com un pro, amb sessions reals, consells personalitzats i tot el que necessites per superar les proves al màxim nivell.",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 29.99,
        shipment: 0.0,
        images: ["/808/image1"],
        banner: ["/808/image1"],
        link: "/tienda/cursos/pack-juny-proves-fisiques-sant-adria/",
        created_at: "2025-05-27 00:00:01",
        start_at: "2025-05-27 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        calendly: { uuid: "ca5c3a76-01bd-4627-a2ca-68347a80687c", units: 4 },
        discount_not_applicable: true,
        parent: 808,
        default_in_parent: true,
    },
    // Tutorització Presencial Policies Locals Catalunya 2025 (6 Juliol - Sessió 5)
    {
        id: 815,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.PL],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-pl-2025-6-juliol-sessio-5",
        title: "Tutorització Presencial Policies Locals Catalunya 2025 (6 Juliol - Sessió 5)",
        name: "Tutorització Presencial Policies Locals Catalunya 2025 (6 Juliol - Sessió 5)",
        short: "5) Tutorització Diumenge 6 Juliol (Sessió 5)",
        description: "Posa't a prova com mai abans! Un entrenament intensiu i personalitzat de 6 hores per superar totes les fases de l'oposició a policies locals.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta especial les primeres 20 matrícules!",
        shipment: 0.0,
        images: ["/676/image5"],
        banner: ["/676/image5"],
        link: "/tienda/cursos/tutoritzacio-policies-locals-catalunya-2025/",
        created_at: "2025-06-01 00:00:00",
        start_at: "2025-06-01 00:00:00",
        more_info: false,
        can_be_sent: false,
        items: 1,
        notify_emails: ["tonicalvo@iopos.academy"],
        parent: 676,
        default_in_parent: true,
    },
    // Actuaciones Policiales contra Delitos Leves
    {
        id: 816,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuaciones-policiales-delitos-leves-2026",
        title: "Curso Actuaciones Policiales contra Delitos Leves",
        name: "Curso Actuaciones Policiales contra Delitos Leves",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curso orientado a conocer y aplicar los protocolos policiales ante delitos leves, garantizando una actuación eficaz, legal y proporcional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/816/image1"],
        banner: ["/816/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-policiales-contra-delitos-leves-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [817, 818],
        multiple_languages: false,
    },
    // Curso Actuaciones Policiales contra Delitos Leves - Idiomas
    {
        id: 817,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuaciones-policiales-delitos-leves-2026-es",
        title: "Curso Actuaciones Policiales contra Delitos Leves",
        name: "Curso Actuaciones Policiales contra Delitos Leves",
        short: "1.) Actuaciones Policiales contra Delitos Leves",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curso orientado a conocer y aplicar los protocolos policiales ante delitos leves, garantizando una actuación eficaz, legal y proporcional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/816/image1"],
        banner: ["/816/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-policiales-contra-delitos-leves-2026/",
        created_at: "2025-05-13 00:00:01",
        start_at: "2025-05-13 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 816,
        default_in_parent: true,
        evolmind: { course_id: 732, group_id: [2424] },
    },
    // Curs Actuacions Policials contra Delictes Lleus - Idiomes
    {
        id: 818,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuaciones-policiales-delitos-leves-2026-ca",
        title: "Curs Actuacions Policials contra Delictes Lleus",
        name: "Curs Actuacions Policials contra Delictes Lleus",
        short: "2.) Actuacions Policials contra Delictes Lleus",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curs orientat a conèixer i aplicar els protocols policials davant delictes lleus, garantint una actuació eficaç, legal i proporcional.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/816/image3"],
        banner: ["/816/image3"],
        link: "/tienda/cursos/formacion-policial/curso-actuaciones-policiales-contra-delitos-leves-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 816,
        evolmind: { course_id: 735, group_id: [2427] },
    },
    // Investigación Policial en el Proceso Penal
    {
        id: 819,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-proceso-penal-2026",
        title: "Curso Investigación Policial en el Proceso Penal",
        name: "Curso Investigación Policial en el Proceso Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formación centrada en el papel de la policía judicial en la fase de instrucción, técnicas de investigación y coordinación con jueces y fiscales.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/819/image1"],
        banner: ["/819/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-policial-proceso-penal-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [820, 821],
        multiple_languages: false,
    },
    // Curso Investigación Policial en el Proceso Penal - Idiomas
    {
        id: 820,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-proceso-penal-2026-es",
        title: "Curso Investigación Policial en el Proceso Penal",
        name: "Curso Investigación Policial en el Proceso Penal",
        short: "1.) Investigación Policial en el Proceso Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formación centrada en el papel de la policía judicial en la fase de instrucción, técnicas de investigación y coordinación con jueces y fiscales.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/819/image1"],
        banner: ["/819/image1"],
        link: "/tienda/cursos/formacion-policial/curso-investigacion-policial-proceso-penal-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 819,
        default_in_parent: true,
        evolmind: { course_id: 738, group_id: [2430] },
    },
    // Curs Investigació Policial en el Procés Penal - Idiomes
    {
        id: 821,
        tax: 0.0,
        sku: "iopos.course.online.curso-investigacion-policial-proceso-penal-2026-ca",
        title: "Curs Investigació Policial en el Procés Penal",
        name: "Curs Investigació Policial en el Procés Penal",
        short: "2.) Investigació Policial en el Procés Penal",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació centrada en el paper de la policia judicial en la fase d'instrucció, tècniques d'investigació i coordinació amb jutges i fiscals.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/816/image3"],
        banner: ["/816/image3"],
        link: "/tienda/cursos/formacion-policial/curso-investgiacion-policial-proceso-penal-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 819,
        evolmind: { course_id: 741, group_id: [2433] },
    },
    // Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad
    {
        id: 822,
        tax: 0.0,
        sku: "iopos.course.online.curso-detenciones-ilegales-cometias-fuerzas-cuerpos-seguridad-2026",
        title: "Curso Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad",
        name: "Curso Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curso especializado en el análisis jurídico y operativo de las detenciones ilegales, su prevención y consecuencias legales.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/822/image1"],
        banner: ["/822/image1"],
        link: "/tienda/cursos/formacion-policial/curso-detenciones-ilegales-cometidas-fuerzas-cuerpos-seguridad-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [823, 824],
        multiple_languages: false,
    },
    // Curso Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad - Idiomas
    {
        id: 823,
        tax: 0.0,
        sku: "iopos.course.online.curso-detenciones-ilegales-cometias-fuerzas-cuerpos-seguridad-2026-es",
        title: "Curso Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad",
        name: "Curso Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad",
        short: "1.) Detenciones Ilegales Cometidas por Fuerzas y Cuerpos de Seguridad",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curso especializado en el análisis jurídico y operativo de las detenciones ilegales, su prevención y consecuencias legales.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/822/image1"],
        banner: ["/822/image1"],
        link: "/tienda/cursos/formacion-policial/curso-detenciones-ilegales-cometidas-fuerzas-cuerpos-seguridad-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 822,
        default_in_parent: true,
        evolmind: { course_id: 744, group_id: [2436] },
    },
    // Curs Detencions Il·legals Comeses per Forces i Cossos de Seguretat - Idiomes
    {
        id: 824,
        tax: 0.0,
        sku: "iopos.course.online.curso-detenciones-ilegales-cometias-fuerzas-cuerpos-seguridad-2026-ca",
        title: "Curs Detencions Il·legas Comeses per Forces i Cossos de Seguretat",
        name: "Curs Detencions Il·legas Comeses per Forces i Cossos de Seguretat",
        short: "2.) Detencions Il·legals Comeses per Forces i Cossos de Seguretat",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Curs especialitzat en l'anàlisi jurídica i operativa de les detencions il·legals, la seva prevenció i conseqüències legals.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/822/image1"],
        banner: ["/822/image1"],
        link: "/tienda/cursos/formacion-policial/curso-detenciones-ilegales-cometidas-fuerzas-cuerpos-seguridad-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 822,
        evolmind: { course_id: 747, group_id: [2439] },
    },
    // Guía Básica de Actuación e Instrucción de Atestados por Delitos Leves
    {
        id: 825,
        tax: 0.21,
        sku: "iopos.course.online.guia-basica-actuacion-instruccion-atestados-delitos-leves-2026",
        title: "Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus",
        name: "Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació especialitzada orientada a garantir una actuació policial rigorosa i una correcta instrucció d’atestats per delictes lleus amb plena seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/825/image2"],
        banner: ["/825/image2"],
        link: "/tienda/cursos/formacion-policial/guia-basica-actuacion-instruccion-atestados-delitos-leves-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [826, 827],
        multiple_languages: false,
    },
    // Guía Básica de Actuación e Instrucción de Atestados por Delitos Leves - Idiomas
    {
        id: 826,
        tax: 0.21,
        sku: "iopos.course.online.guia-basica-actuacion-instruccion-atestados-delitos-leves-2026-es",
        title: "Guía Básica de Actuación e Instrucción de Atestados por Delitos Leves",
        name: "Guía Básica de Actuación e Instrucción de Atestados por Delitos Leves",
        short: "1.) Guía Básica de Actuación e Instrucción de Atestados por Delitos Leves",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Manual práctico para la correcta redacción de atestados policiales y actuaciones básicas ante delitos leves.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/825/image1"],
        banner: ["/825/image1"],
        link: "/tienda/cursos/formacion-policial/guia-basica-actuacion-instruccion-atestados-delitos-leves-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 825,
        default_in_parent: true,
        evolmind: { course_id: 964, group_id: [2803] },
    },
    // Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus - Idiomes
    {
        id: 827,
        tax: 0.21,
        sku: "iopos.course.online.guia-basica-actuacion-instruccion-atestados-delitos-leves-2026-ca",
        title: "Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus",
        name: "Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus",
        short: "1.) Guia Bàsica d'Actuació i Instrucció d'Atestats per Delictes Lleus",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Manual pràctic per a la correcta redacció d'atestats policials i actuacions bàsiques davant delictes lleus.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/825/image1"],
        banner: ["/825/image1"],
        link: "/tienda/cursos/formacion-policial/guia-basica-actuacion-instruccion-atestados-delitos-leves-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 825,
        evolmind: { course_id: 753, group_id: [2445] },
    },
    // 828. Las Fuentes del Derecho
    {
        id: 828,
        tax: 0.0,
        sku: "iopos.course.online.curso-las-fuentes-del-derecho-2026",
        title: "Curs Les Fonts del Dret",
        name: "Curso Les Fonts del Dret",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Formació especialitzada orientada a comprendre l'ordenament jurídic com un sistema estructurat de normes i a aplicar correctament el principi de jerarquia normativa en l’actuació policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/828/image2"],
        banner: ["/828/image2"],
        link: "/tienda/cursos/formacion-policial/curso-las-fuentes-del-derecho-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [829, 830],
        multiple_languages: false,
        homologated: [
            {
                code: "RP20250071106",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 36,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        hero: {
            firstTitle: "Curs Homologat de les Fonts del Dret",
            secondTitle: "ISPC 2026",
            thirdTitle: "Formació **especialitzada** orientada a **comprendre** l'**ordenament jurídic** com un sistema estructurat de normes i a **aplicar correctament** el **principi de jerarquia normativa** en l’**actuació policial**.",
            landscape: "/828/hero_h",
            portrait: "/828/hero_v",
        },
    },
    // Curso Las Fuentes del Derecho - Idiomas
    {
        id: 829,
        tax: 0.0,
        sku: "iopos.course.online.curso-las-fuentes-del-derecho-2026-es",
        title: "Curso Las Fuentes del Derecho",
        name: "Curso Las Fuentes del Derecho",
        short: "1.) Las Fuentes del Derecho",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Curso introductorio sobre las fuentes formales del ordenamiento jurídico español y su aplicación en el ámbito policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/828/image2"],
        banner: ["/828/image2"],
        link: "/tienda/cursos/formacion-policial/curso-las-fuentes-del-derecho-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 828,
        default_in_parent: true,
        evolmind: { course_id: 756, group_id: [2448] },
    },
    // Curs Les Fonts del Dret - Idiomes
    {
        id: 830,
        tax: 0.0,
        sku: "iopos.course.online.curso-las-fuentes-del-derecho-2026-ca",
        title: "Curs Les Fonts del Dret",
        name: "Curso Les Fonts del Dret",
        short: "1.) Les Fonts del Dret",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
            product_types_1.Category.HOMOLOGADOS,
        ],
        description: "Curs introductori sobre les fonts formals de l'ordenament jurídic espanyol i la seva aplicació en l'àmbit policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/828/image2"],
        banner: ["/828/image2"],
        link: "/tienda/cursos/formacion-policial/curso-las-fuentes-del-derecho-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 828,
        evolmind: { course_id: 759, group_id: [2451] },
    },
    // Curso Ley 39/2015. Ámbito Policial
    {
        id: 831,
        tax: 0.21,
        sku: "iopos.course.online.curso-ley-39-2015-ambito-policial-2026",
        title: "Curs Llei 39/2015. Àmbit Policial",
        name: "Curs Llei 39/2015. Àmbit Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació especialitzada orientada a aplicar amb seguretat jurídica la Llei 39/2015 en totes les actuacions policials amb transcendència administrativa.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/831/image2"],
        banner: ["/831/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ley-39-2015-ambito-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [832, 833],
        multiple_languages: false,
    },
    // Curso Ley 39/2015. Ámbito Policial - Idiomas
    {
        id: 832,
        tax: 0.21,
        sku: "iopos.course.online.curso-ley-39-2015-ambito-policial-2026-es",
        title: "Curso Ley 39/2015. Ámbito Policial",
        name: "Curso Ley 39/2015. Ámbito Policial",
        short: "1.) Ley 39/2015. Ámbito Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formación enfocada en los aspectos clave de la Ley 39/2015 del procedimiento administrativo común, aplicada a la función policial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/831/image2"],
        banner: ["/831/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ley-39-2015-ambito-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 831,
        default_in_parent: true,
        evolmind: { course_id: 762, group_id: [2454] },
    },
    // Curs Llei 39/2015. Àmbit Policial - Idiomes
    {
        id: 833,
        tax: 0.21,
        sku: "iopos.course.online.curso-ley-39-2015-ambito-policial-2026-ca",
        title: "Curs Llei 39/2015. Àmbit Policial",
        name: "Curs Llei 39/2015. Àmbit Policial",
        short: "1.) Llei 39/2015. Àmbit Policial",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_PENAL_Y_PROCESAL,
        ],
        description: "Formació enfocada en els aspectes clau de la Llei 39/2015 del procediment administratiu comú, aplicada a la funció policial.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/831/image2"],
        banner: ["/831/image2"],
        link: "/tienda/cursos/formacion-policial/curso-ley-39-2015-ambito-policial-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 831,
        evolmind: { course_id: 765, group_id: [2457] },
    },
    // Tutorització Presencial Mossos d'Esquadra 2025
    {
        id: 834,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Mossos],
        tax: 0.0,
        sku: "iopos.course.f2f.2025-tutoritzacio-mossos-2025",
        title: "Tutorització Presencial Mossos d'Esquadra 2025",
        name: "Tutorització Presencial Mossos d'Esquadra 2025",
        description: "Posa't a prova com mai abans! 💪🔥 En només 5 hores, prepara totes les parts de l'oposició amb docents especialitzats i una metodologia única. Reserva la teva plaça ara i assegura el teu futur!",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/677/image2"],
        banner: ["/677/image2"],
        link: "/tienda/cursos/tutoritzacio-presencial-mossos-desquadra-2025/",
        created_at: "2025-09-07 00:00:01",
        start_at: "2025-09-07 00:00:01",
        more_info: true,
        can_be_sent: false,
        items: 1,
        notify_emails: ["txema@iopos.academy"],
        // childs: [923, 935],
    },
    // Policía Administrativa. Juegos y espectáculos
    {
        id: 835,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-administrativa-juegos-espectaculos-2026",
        title: "Curso Policía Administrativa. Juegos y espectáculos",
        name: "Curso Policía Administrativa. Juegos y espectáculos",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curso centrado en la normativa y funciones policiales relacionadas con la vigilancia y control de juegos, apuestas y espectáculos públicos.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/835/image1"],
        banner: ["/835/image1"],
        link: "/tienda/cursos/formacion-policial/policia-administrativoa-juegos-y-espectaculos-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: true,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [836, 837],
        multiple_languages: false,
    },
    // Curso Policía Administrativa. Juegos y espectáculos - Idiomas
    {
        id: 836,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-administrativa-juegos-espectaculos-2026-es",
        title: "Curso Policía Administrativa. Juegos y espectáculos",
        name: "Curso Policía Administrativa. Juegos y espectáculos",
        short: "1.) Policía Administrativa. Juegos y espectáculos",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curso centrado en la normativa y funciones policiales relacionadas con la vigilancia y control de juegos, apuestas y espectáculos públicos.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/835/image1"],
        banner: ["/835/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-administrativa-juegos-y-espectaculos-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 835,
        default_in_parent: true,
        evolmind: { course_id: 768, group_id: [2463] },
    },
    // Curs Policia Administrativa. Jocs i espectacles - Idiomes
    {
        id: 837,
        tax: 0.0,
        sku: "iopos.course.online.curso-policia-administrativa-juegos-espectaculos-2026-ca",
        title: "Curs Policia Administrativa. Jocs i espectacles",
        name: "Curs Policia Administrativa. Jocs i espectacles",
        short: "2.) Policia Administrativa. Jocs i espectacles",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curs centrat en la normativa i funcions policials relacionades amb la vigilància i control de jocs, apostes i espectacles públics.",
        enabled: false,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/835/image1"],
        banner: ["/835/image1"],
        link: "/tienda/cursos/formacion-policial/curso-policia-administrativa-juegos-y-espectaculos-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 835,
        evolmind: { course_id: 771, group_id: [2466] },
    },
    // La inspección administrativa
    {
        id: 838,
        tax: 0.21,
        sku: "iopos.course.online.curso-la-inspeccion-administrativa-2026",
        title: "Curs de la Inspecció Administrativa",
        name: "Curs de la Inspecció Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Formació especialitzada orientada a l'exercici de la inspecció administrativa amb criteri professional, rigor procedimental i seguretat jurídica.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/838/image2"],
        banner: ["/838/image2"],
        link: "/tienda/cursos/formacion-policial/curso-la-inspeccion-administrativa-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [839, 840],
        multiple_languages: false,
    },
    // Curso de la Inspección Administrativa - Idiomas
    {
        id: 839,
        tax: 0.21,
        sku: "iopos.course.online.curso-la-inspeccion-administrativa-2026-es",
        title: "Curso de la Inspección Administrativa",
        name: "Curso de la Inspección Administrativa",
        short: "1.) La Inspección Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Formació pràctica sobre el procediment, requisits legals i documentació en les inspeccions administratives realitzades per la policia.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/838/image2"],
        banner: ["/838/image2"],
        link: "/tienda/cursos/formacion-policial/curso-la-inspeccion-administrativa-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 838,
        default_in_parent: true,
        evolmind: { course_id: 774, group_id: [2469] },
    },
    // Curs de la Inspecció Administrativa - Idiomes
    {
        id: 840,
        tax: 0.21,
        sku: "iopos.course.online.curso-la-inspeccion-administrativa-2026-ca",
        title: "Curs de la Inspecció Administrativa",
        name: "Curs de la Inspecció Administrativa",
        short: "1.) La Inspecció Administrativa",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Formació pràctica sobre el procediment, requisits legals i documentació en les inspeccions administratives realitzades per la policia.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/838/image2"],
        banner: ["/838/image2"],
        link: "/tienda/cursos/formacion-policial/curso-la-inspeccion-administrativa-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 838,
        evolmind: { course_id: 777, group_id: [2472] },
    },
    // Inspecciones de establecimientos de concurrencia pública, musicales y otros
    {
        id: 841,
        tax: 0.21,
        sku: "iopos.course.online.curso-inspecciones-establec-conc-publica-musicales-otros-2026",
        title: "Curs Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres",
        name: "Curs Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Formació especialitzada orientada a la inspecció, control i seguretat jurídica dels establiments de pública concurrència i activitats recreatives.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/841/image2"],
        banner: ["/841/image2"],
        link: "/tienda/cursos/formacion-policial/curso-inspecciones-establecimientos-concurrencia-publica-musicales-otros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [842, 843],
        multiple_languages: false,
    },
    // Curso Inspecciones de Establecimientos de Concurrencia Pública, Musicales y Otros - Idiomas
    {
        id: 842,
        tax: 0.21,
        sku: "iopos.course.online.curso-inspecciones-establec-conc-publica-musicales-otros-2026-es",
        title: "Curso Inspecciones de Establecimientos de Concurrencia Pública, Musicales y Otros",
        name: "Curso Inspecciones de Establecimientos de Concurrencia Pública, Musicales y Otros",
        short: "1.) Inspecciones de Establecimientos de Concurrencia Pública, Musicales y Otros",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curso especializado en la normativa y operativa para inspeccionar locales con afluencia de público, como bares, salas de conciertos y discotecas.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/841/image2"],
        banner: ["/841/image2"],
        link: "/tienda/cursos/formacion-policial/curso-inspecciones-establecimientos-concurrencia-publica-musicales-otros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 841,
        default_in_parent: true,
        evolmind: { course_id: 780, group_id: [2475] },
    },
    // Curs Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres - Idiomes
    {
        id: 843,
        tax: 0.21,
        sku: "iopos.course.online.curso-inspecciones-establec-conc-publica-musicales-otros-2026-ca",
        title: "Curs Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres",
        name: "Curs Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres",
        short: "1.) Inspeccions d'Establiments de Concurrència Pública, Musicals i Altres",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curs especialitzat en la normativa i operativa per inspeccionar locals amb afluència de públic, com bars, sales de concerts i discoteques.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/841/image2"],
        banner: ["/841/image2"],
        link: "/tienda/cursos/formacion-policial/curso-inspecciones-establecimientos-concurrencia-publiuca-musicales-y-otros-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 838,
        evolmind: { course_id: 783, group_id: [2478] },
    },
    // Reglamento general de conductores, permisos de conducir y materia de extranjería aplicable
    {
        id: 844,
        tax: 0.0,
        sku: "iopos.course.online.curso-reglamento-general-conductores-permisos-conducir-2026",
        title: "Curs Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable",
        name: "Curs Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a garantir la seguretat jurídica i la correcta aplicació de la normativa de trànsit en les actuacions policials.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/844/image2"],
        banner: ["/844/image2"],
        link: "/tienda/cursos/formacion-policial/curso-reglamento-general-conductores-permisos-conducir-materia-extrangeria-aplicable-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [845, 846],
        multiple_languages: false,
    },
    // Curso Reglamento General de Conductores, Permisos de Conducir y Materia de Extranjería Aplicable - Idiomas
    {
        id: 845,
        tax: 0.0,
        sku: "iopos.course.online.curso-reglamento-general-conductores-permisos-conducir-2026-es",
        title: "Curso Reglamento General de Conductores, Permisos de Conducir y Materia de Extranjería Aplicable",
        name: "Curso Reglamento General de Conductores, Permisos de Conducir y Materia de Extranjería Aplicable",
        short: "1.) Reglamento General de Conductores, Permisos de Conducir y Materia de Extranjería Aplicable",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formación completa sobre el Reglamento General de Conductores, clases de permisos, normativa vial y aspectos básicos de extranjería.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/844/image1"],
        banner: ["/844/image1"],
        link: "/tienda/cursos/formacion-policial/curso-reglamento-general-conductores-permisos-conducir-materia-extranjeria-aplicable-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 844,
        default_in_parent: true,
        evolmind: { course_id: 786, group_id: [2481] },
    },
    // Curs Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable - Idiomes
    {
        id: 846,
        tax: 0.0,
        sku: "iopos.course.online.curso-reglamento-general-conductores-permisos-conducir-2026-ca",
        title: "Curs Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable",
        name: "Curs Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable",
        short: "1.) Reglament General de Conductors, Permisos de Conduir i Matèria d'Estrangeria Aplicable",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació completa sobre el Reglament General de Conductors, classes de permisos, normativa viària i aspectes bàsics d'estrangeria.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/844/image1"],
        banner: ["/844/image1"],
        link: "/tienda/cursos/formacion-policial/curso-reglamento-general-conductores-permisos-conducir-materia-extranjeria-aplicable-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 844,
        evolmind: { course_id: 789, group_id: [2484] },
    },
    // Targetas de personas con movilidad reducida
    {
        id: 847,
        tax: 0.21,
        sku: "iopos.course.online.curso-tarjetas-personas-movilidad-reducida-2026",
        title: "Curs Targetes de Persones amb Mobilitat Reduïda",
        name: "Curs Targetes de Persones amb Mobilitat Reduïda",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Formació especialitzada orientada a garantir una aplicació correcta de la normativa d’accessibilitat i a prevenir l’ús fraudulent de les targetes d’estacionament per a persones amb mobilitat reduïda.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/847/image2"],
        banner: ["/847/image2"],
        link: "/tienda/cursos/formacion-policial/curso-tarjetas-personas-movilidad-reducida-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [848, 849],
        multiple_languages: false,
    },
    // Curso Tarjetas de Personas con Movilidad Reducida - Idiomas
    {
        id: 848,
        tax: 0.21,
        sku: "iopos.course.online.curso-tarjetas-personas-movilidad-reducida-2026-es",
        title: "Curso Tarjetas de Personas con Movilidad Reducida",
        name: "Curso Tarjetas de Personas con Movilidad Reducida",
        short: "1.) Tarjetas de Personas con Movilidad Reducida",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curso específico sobre el régimen jurídico, requisitos y control del uso de tarjetas para personas con movilidad reducida.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/847/image2"],
        banner: ["/847/image2"],
        link: "/tienda/cursos/formacion-policial/curso-tarjetas-personas-movilidad-reducida-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 847,
        default_in_parent: true,
        evolmind: { course_id: 792, group_id: [2487] },
    },
    // Curs Targetes de Persones amb Mobilitat Reduïda - Idiomes
    {
        id: 849,
        tax: 0.21,
        sku: "iopos.course.online.curso-tarjetas-personas-movilidad-reducida-2026-ca",
        title: "Curs Targetes de Persones amb Mobilitat Reduïda",
        name: "Curs Targetes de Persones amb Mobilitat Reduïda",
        short: "1.) Targetes de Persones amb Mobilitat Reduïda",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.DERECHO_ADMINISTRATIVO_Y_REGIMEN_SANCIONADOR,
        ],
        description: "Curs específic sobre el règim jurídic, requisits i control de l'ús de targetes per a persones amb mobilitat reduïda.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/847/image2"],
        banner: ["/847/image2"],
        link: "/tienda/cursos/formacion-policial/curso-tarjetas-personas-movilidad-reducida-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 847,
        evolmind: { course_id: 795, group_id: [2490] },
    },
    // Formación específica en la prueba de drogoalcoholemia
    {
        id: 850,
        tax: 0.0,
        sku: "iopos.course.online.curso-formacion-especifica-prueba-drogoalcoholemia-2026",
        title: "Curs Formació Específica amb la Prova de Drogoalcoholèmia",
        name: "Curs Formació Específica amb la Prova de Drogoalcoholèmia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a actualitzar els coneixements normatius i operatius en matèria de proves de drogoalcoholèmia, garantint una actuació policial rigorosa i jurídicament segura.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/850/image1"],
        banner: ["/850/image1"],
        link: "/tienda/cursos/formacion-policial/curso-formacion-especifica-prueba-drogoalcoholemia-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [851, 852],
        multiple_languages: false,
    },
    // Curso Formación Específica en la Prueba de Drogoalcoholemia - Idiomas
    {
        id: 851,
        tax: 0.0,
        sku: "iopos.course.online.curso-formacion-especifica-prueba-drogoalcoholemia-2026-es",
        title: "Curso Formación Específica en la Prueba de Drogoalcoholemia",
        name: "Curso Formación Específica en la Prueba de Drogoalcoholemia",
        short: "1.) Formación Específica en la Prueba de Drogoalcoholemia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso práctico orientado a la correcta realización de pruebas de detección de alcohol y drogas en conductores, conforme a la normativa vigente. Incluye aspectos técnicos, legales y procedimentales aplicables por las fuerzas policiales.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/850/image1"],
        banner: ["/850/image1"],
        link: "/tienda/cursos/formacion-policial/curso-tarjetas-personas-movilidad-reducida-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 850,
        default_in_parent: true,
        evolmind: { course_id: 798, group_id: [2493] },
    },
    // Curs Formació Específica amb la Prova de Drogoalcoholèmia - Idiomes
    {
        id: 852,
        tax: 0.0,
        sku: "iopos.course.online.curso-formacion-especifica-prueba-drogoalcoholemia-2026-ca",
        title: "Curs Formació Específica amb la Prova de Drogoalcoholèmia",
        name: "Curs Formació Específica amb la Prova de Drogoalcoholèmia",
        short: "1.) Formació Específica amb la Prova de Drogoalcoholèmia",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curs pràctic orientat a la correcta realització de proves de detecció d'alcohol i drogues en conductors, d'acord amb la normativa vigent. Inclou aspectes tècnics, legals i procedimentals aplicables per les forces policials.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/850/image1"],
        banner: ["/850/image1"],
        link: "/tienda/cursos/formacion-policial/curso-formacion-especifica-prueba-drogoalcoholemia-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 850,
        evolmind: { course_id: 801, group_id: [2496] },
    },
    // Curso de actuación y actualización en materia de vehículos de movilidad personal y bicicletas de pedaleo asistido
    {
        id: 853,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-actualizacion-materia-vehiculos-movilidad-personal-2026",
        title: "Curs d'Actuació i Actualització en Matèria de Vehicles de Mobilitat Personal i Bicicletes de Pedaleo Assistit",
        name: "Curs d'Actuació i Actualització en Matèria de Vehicles de Mobilitat Personal i Bicicletes de Pedaleo Assistit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a garantir una actuació policial actualitzada, homogènia i jurídicament segura en matèria de Vehicles de Mobilitat Personal (VMP) i bicicletes de pedaleig assistit (EPAC).",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/853/image1"],
        banner: ["/853/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-actualizacion-materia-vehiculos-movilidad-personal-bicicletas-pedaleo-asistido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [854, 855],
        multiple_languages: false,
    },
    // Curso de actuación y actualización en materia de vehículos de movilidad personal y bicicletas de pedaleo asistido - Idiomas
    {
        id: 854,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-actualizacion-materia-vehiculos-movilidad-personal-2026-es",
        title: "Curso de Actuación y Actualización en Materia de Vehículos de Movilidad Personal y Bicicletas de Pedaleo Asistido",
        name: "Curso de Actuación y Actualización en Materia de Vehículos de Movilidad Personal y Bicicletas de Pedaleo Asistido",
        short: "1.) Actuación y Actualización en Materia de Vehículos de Movilidad Personal y Bicicletas de Pedaleo Asistido",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso especializado para la actualización normativa y operativa en relación con los vehículos de movilidad personal (VMP) y las bicicletas de pedaleo asistido. Incluye criterios de intervención policial, regulación de uso, documentación, seguridad vial y respuesta ante infracciones",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/854/image1"],
        banner: ["/854/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacion-actualizacion-materia-vehiculos-movilidad-personal-bicicletas-pedaleo-asistido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 850,
        default_in_parent: true,
        evolmind: { course_id: 804, group_id: [2499] },
    },
    // Curs d'actuació i actualització en matèria de vehicles de mobilitat personal i bicicletes de pedaleo assistit - Idiomes
    {
        id: 855,
        tax: 0.0,
        sku: "iopos.course.online.curso-actuacion-actualizacion-materia-vehiculos-movilidad-personal-2026-ca",
        title: "Curs d'Actuació i Actualització en Matèria de Vehicles de Mobilitat Personal i Bicicletes de Pedaleo Assistit",
        name: "Curs d'Actuació i Actualització en Matèria de Vehicles de Mobilitat Personal i Bicicletes de Pedaleo Assistit",
        short: "1.) Actuació i Actualització en Matèria de Vehicles de Mobilitat Personal i Bicicletes de Pedaleo Assistit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curs especialitzat per a l'actualització normativa i operativa en relació amb els vehicles de mobilitat personal (VMP) i les bicicletes de pedaleig assistit. Inclou criteris d'intervenció policial, regulació d'ús, documentació, seguretat viària i resposta davant infraccions.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/853/image1"],
        banner: ["/853/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actuacio-actualitzacion-materia-vehiculos-movilidad-personal-bicicletas-pedaleo-asistido-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 853,
        evolmind: { course_id: 807, group_id: [2502] },
    },
    // Actualización en materia de tráfico
    {
        id: 856,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-normativa-legislacion-materia-de-trafico-2026",
        title: "Curs d'Actualització en Normativa i Legislació en Matèria de Trànsit",
        name: "Curs d'Actualització en Normativa i Legislació en Matèria de Trànsit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Formació especialitzada orientada a actualitzar els coneixements normatius i operatius en matèria de trànsit, garantint una actuació policial segura, eficaç i jurídicament ajustada.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 44.99,
        shipment: 0.0,
        images: ["/856/image1"],
        banner: ["/856/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-normativa-legislacion-materia-de-trafico-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        childs: [857, 858],
        multiple_languages: false,
    },
    // Curso de actualización en normativa y legislación en materia de tráfico - Idiomas
    {
        id: 857,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-normativa-legislacion-materia-de-trafico-2026-es",
        title: "Curso de Actualización en Normativa y Legislación en Materia de Tráfico",
        name: "Curso de Actualización en Normativa y Legislación en Materia de Tráfico",
        short: "1.) Actualización en Normativa y Legislación en Materia de Tráfico",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curso orientado a la actualización de conocimientos en normativa de tráfico, intervención policial en la vía pública, documentación, infracciones y novedades legislativas. Dirigido a profesionales que requieren mantener al día su formación en seguridad vial.",
        enabled: true,
        stock: false,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/856/image1"],
        banner: ["/856/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-normativa-legislacion-materia-de-trafico-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 856,
        default_in_parent: true,
        evolmind: { course_id: 810, group_id: [2505] },
    },
    // Curs d'actualització en normativa i legislació en matèria de trànsit - Idiomes
    {
        id: 858,
        tax: 0.0,
        sku: "iopos.course.online.curso-actualizacion-normativa-legislacion-materia-de-trafico-2026-ca",
        title: "Curs d'Actualització en Normativa i Legislació en Matèria de Trànsit",
        name: "Curs d'Actualització en Normativa i Legislació en Matèria de Trànsit",
        short: "1.) Actualització en Normativa i Legislació en Matèria de Trànsit",
        category: [
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
            product_types_1.Category.TRAFICO_Y_SEGURIDAD_VIAL,
        ],
        description: "Curs orientat a l'actualització de coneixements en normativa de trànsit, intervenció policial a la via pública, documentació, infraccions i novetats legislatives. Adreçat a professionals que necessiten mantenir al dia la seva formació en seguretat viària.",
        enabled: true,
        stock: true,
        stock_message: "Disponible i actualitzat en breu!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 39.99,
        shipment: 0.0,
        images: ["/856/image1"],
        banner: ["/856/image1"],
        link: "/tienda/cursos/formacion-policial/curso-actualizacion-normativa-legislacion-materia-de-trafico-2026/",
        created_at: "2025-06-01 00:00:01",
        start_at: "2025-06-01 00:00:01",
        more_info: false,
        release: true,
        can_be_sent: false,
        items: 1,
        multiple_languages: false,
        parent: 856,
        evolmind: { course_id: 813, group_id: [2508] },
    },
];
exports.default = products;
